// Single definition of won/lost stages (Jeff, 2026-10-14). Mirrors data/stage_rules.py: 'P.O. Issued,...'
// and 'PO Received by ...' count as WON, same as 'Closed Won'. Never test stage text inline elsewhere
// (tools/static_guards.py `stagerules`).
export function isWonStage(stage) {
  const s = String(stage || '').trim().toLowerCase();
  return s.includes('closed won') || s.startsWith('p.o. issued') || s.startsWith('po received');
}

export function isLostStage(stage) {
  return String(stage || '').toLowerCase().includes('closed lost');
}

export function isOpenStage(stage) {
  const s = String(stage || '').toLowerCase();
  return !!s && !s.includes('closed') && !isWonStage(s);
}

export function stageChipColor(stage) {
  if (!stage) return 'default';
  if (isWonStage(stage)) return 'success';
  if (isLostStage(stage)) return 'error';
  return 'info';
}

export function stageLabel(stage) {
  if (!stage) return stage;
  if (isWonStage(stage)) return stage.replace('Closed Won', '✓ Won');
  return stage.replace('Closed Lost', '✗ Lost');
}
